import importAllFiles from '@support/importAllFiles';
import { useTheme } from '@hooks/use-theme';
import { ContactInfo } from '@app/types';

type AssetPath = string;

interface ThemedIconForSourceOpts {
  baseIconOnIntegration?: boolean;
}

const icons = importAllFiles(import.meta.glob('/public/img/contact/icons/source/*.svg'));

export const useThemedIconForSource = (
  source: ContactInfo,
  { baseIconOnIntegration }: ThemedIconForSourceOpts = {},
): AssetPath | undefined => {
  const [theme] = useTheme();
  let iconKey: string = source.type;

  if (baseIconOnIntegration) {
    switch (source.source) {
      case 'CL':
        iconKey = 'calendar';
        break;
      case 'TW':
        iconKey = 'twitter';
        break;
      case 'FB':
        iconKey = 'facebook';
        break;
      case 'LI':
        iconKey = 'linkedin';
        break;
      case 'ME':
      case 'EM':
        iconKey = 'email';
        break;
      case 'MA':
      case 'BI':
      case 'SS':
        iconKey = 'manual';
        break;
    }

    if (source.type === 'phone') {
      iconKey = 'phone';
    }

    if (source.type === 'messages') {
      iconKey = 'messages';
    }

    if (source.type === 'email' && !iconKey) {
      iconKey = 'email';
    }
  }

  if (!iconKey) {
    return undefined;
  }

  return icons[`${iconKey}_${theme}`] || icons[iconKey];
};
